import { ContactDetailsForm } from '@components/ContactDetailsForm';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { t } from '@lingui/core/macro';
import { NoddiButton, noddiToast } from 'noddi-ui-web';
import { Account as AccountNoddiUi } from 'noddi-web';
import { useState } from 'react';
import { getCommonTranslations } from '../../../utils/commonTranslations';

// Temporarily disabled for customer until the flow is fully rolled out.
const ENABLE_CUSTOMER_PASSWORD_CHANGE = false;

export const EditAccount = () => {
  const [contactDetail, setContactDetail] = useState<'email' | 'phoneNumber' | null>(null);
  const handleSuccess = () => {
    noddiToast.success(t`Profile updated successfully`);
  };

  return (
    <ContentWrapperCustomerApp title={t`Edit account`}>
      <AccountNoddiUi
        enablePasswordChange={ENABLE_CUSTOMER_PASSWORD_CHANGE}
        requireContactDetails
        onSuccess={handleSuccess}
        emailAction={
          <NoddiButton type='button' variant='outline' onClick={() => setContactDetail('email')}>
            {t`Edit`}
          </NoddiButton>
        }
        phoneNumberAction={
          <NoddiButton type='button' variant='outline' onClick={() => setContactDetail('phoneNumber')}>
            {t`Edit`}
          </NoddiButton>
        }
        translations={{
          profileUpdatedSuccessfully: getCommonTranslations().profileUpdatedSuccessfully,
          firstName: getCommonTranslations().firstName,
          lastName: getCommonTranslations().lastName,
          email: getCommonTranslations().email,
          phoneNumber: getCommonTranslations().phoneNumber,
          save: getCommonTranslations().save,
          language: getCommonTranslations().language,
          validation: {
            required: getCommonTranslations().required
          }
        }}
      />
      {contactDetail && (
        <ContactDetailsForm field={contactDetail} onClose={() => setContactDetail(null)} onSuccess={handleSuccess} />
      )}
    </ContentWrapperCustomerApp>
  );
};
